// @ts-nocheck

import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'

export default function DateTimeCell(props) {
  const { style, value } = props

  return <div style={style}>{dayjs(value).format('DD-MM-YYYY HH:mm')}</div>
}

DateTimeCell.propTypes = {
  style: PropTypes.object,
  value: PropTypes.string.isRequired,
}
